import Home from "@/views/public/Home.vue";

export default {
  path: "/",
  name: "home",
  component: Home
};
